// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-data-table[data-v-a2ac62d4] .v-data-table__wrapper {\n  overflow: unset;\n}\n", ""]);
// Exports
module.exports = exports;
